import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useBackofficeSearchCondition } from '@/providers/BackofficeSearchConditionProvider';
import { ListElement } from '@/features/w/[identifier]/backoffice/invoice_tasks/{components}/ListElement';
import { FilterModal } from '@/features/w/[identifier]/backoffice/invoice_tasks/{components}/FilterModal';
import { SearchConditionTags } from '@/features/w/[identifier]/backoffice/invoice_tasks/{components}/SearchConditionTags';
import { KanbanElement } from '@/features/w/[identifier]/backoffice/invoice_tasks/{components}/KanbanElement';
import { CsvExport } from '@/features/w/[identifier]/backoffice/invoice_tasks/{components}/CsvExport';

export const BackofficeInvoiceTasks = () => {
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle('請求タスク一覧'), []);
  useEffect(() => setBreadcrumbs([]), []);
  const { invoiceTaskDisplayType: displayType, setInvoiceTaskDisplayType: setDisplayType } =
    useBackofficeSearchCondition();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <div className="container-fluid py-4">
        <div className="d-flex align-items-center mb-4">
          <div className="btn-group">
            <button
              className={`btn btn-icon ${displayType == 'list' ? 'btn-dark' : 'btn-outline-dark'}`}
              onClick={() => setDisplayType('list')}
            >
              <i className="fas fa-th-list"></i>リスト
            </button>
            <button
              className={`btn btn-icon ${displayType == 'kanban' ? 'btn-dark' : 'btn-outline-dark'}`}
              onClick={() => setDisplayType('kanban')}
            >
              <i className="fas fa-th-large"></i>ボード
            </button>
          </div>
          <button className="btn btn-icon-only btn-dark mx-2" data-bs-toggle="modal" data-bs-target="#modal-filter">
            <i className="fas fa-filter"></i>
          </button>

          <CsvExport />
        </div>

        <SearchConditionTags />

        <FilterModal />

        {displayType == 'list' && <ListElement />}
        {displayType == 'kanban' && <KanbanElement />}
      </div>
    </WorkspaceLayout>
  );
};
